import { CustomerUserConfigTradingLayoutArrangements, ResizerPlacement } from '@talos/kyoko';
import { Blotters } from '../../../components/Blotters/Blotters';
import { Candlesticks } from '../../../components/Candlesticks';
import { VolumeLadder } from '../../../components/VolumeLadder';
import { BLOTTERS_MIN_HEIGHT, MAIN_HEADER_HEIGHT, VOLUME_LADDER_HEIGHT } from '../../../styles/dimensions';
import { viewOnlyMobileScreens } from '../../mobileScreens';
import type { LayoutComponentArrangement } from '../../types';

export const SingleSymbolViewArrangement: LayoutComponentArrangement = {
  columns: ['minmax(16rem,1fr)', 'minmax(16rem,24rem)'],
  displayName: CustomerUserConfigTradingLayoutArrangements.SingleSymbolView,
  rows: [`minmax(${VOLUME_LADDER_HEIGHT}px,1fr)`, 'minmax(0px,1fr)', `minmax(${BLOTTERS_MIN_HEIGHT}px,1fr)`],
  parts: [
    {
      column: '1',
      row: '1/3',
      component: <Candlesticks />,
    },
    {
      column: '2',
      row: '1/3',
      component: <VolumeLadder />,
    },
    {
      column: '1/3',
      row: '3',
      component: <Blotters />,
      minHeight: BLOTTERS_MIN_HEIGHT,
      maxHeight: window.innerHeight - MAIN_HEADER_HEIGHT - VOLUME_LADDER_HEIGHT - 20,
      resizable: ResizerPlacement.TOP,
    },
  ],
  mobileScreens: viewOnlyMobileScreens,
};
